import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Brand from "@/components/Brand";
import { Lock, Mail, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("faizabdullah@arisyagroup.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", {
        email: email.trim().toLowerCase(),
        password,
      });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen auth-bg flex items-center justify-center px-4 py-12 relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Brand size="lg" />
        </div>

        <div className="bg-[#101010] border border-amber-500/20 rounded-2xl p-8 shadow-2xl shadow-black/60">
          <div className="mb-6">
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber-500/80 font-semibold mb-2">
              Panel Pentadbir
            </div>
            <h1 className="font-display text-3xl font-bold mb-2">Pintu Belakang.</h1>
            <p className="text-sm text-neutral-400">
              Hanya untuk pentadbir Face Club.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-xs text-neutral-500 mb-2 font-mono uppercase tracking-wider">Emel</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" size={18} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 bg-[#0A0A0A] border border-white/10 rounded-md text-white focus:border-amber-500/60 focus:outline-none font-mono text-sm"
                  data-testid="admin-email-input"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs text-neutral-500 mb-2 font-mono uppercase tracking-wider">
                Kata laluan
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" size={18} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-11 pr-4 py-3 bg-[#0A0A0A] border border-white/10 rounded-md text-white focus:border-amber-500/60 focus:outline-none font-mono text-sm"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            {error && (
              <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-4 py-3" data-testid="admin-login-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="admin-login-submit-btn">
              {loading ? "Mengesahkan…" : (<>Akses Panel <ArrowRight size={18} /></>)}
            </button>
          </form>

          <div className="divider-gold my-6" />

          <Link to="/login" className="block text-xs text-center text-neutral-500 hover:text-amber-400 transition-colors" data-testid="participant-login-link">
            ← Kembali ke log masuk ahli
          </Link>
        </div>
      </div>
    </div>
  );
}
